function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { makeParamsObj, makeParamsObjFromSassMap, makeComplexAttributePropType } from './../../utils/helpers';
import { UI } from './../../utils';
import { Color, Display } from './../../enhancers';
import css from './Icon.sass';
import * as ICONS from './_Icons';
var iconNames =
/*#__PURE__*/
Object.keys(ICONS);
var localPropsMap =
/*#__PURE__*/
makeParamsObjFromSassMap(css.props);
var breakpoint =
/*#__PURE__*/
makeParamsObj(UI.BREAKEPOINTS);
var sizes =
/*#__PURE__*/
makeParamsObjFromSassMap(css.sizes);
var vAligns =
/*#__PURE__*/
makeParamsObjFromSassMap(css.vAligns);

function BaseIcon(props) {
  var name = props.name,
      icon = props.icon,
      svg = props.svg,
      pointer = props.pointer,
      color = props.color,
      size = props.size,
      sizeXS = props.sizeXS,
      sizeS = props.sizeS,
      sizeM = props.sizeM,
      sizeL = props.sizeL,
      sizeXL = props.sizeXL,
      className = props.className,
      vAlign = props.vAlign,
      children = props.children;
  var classNames = cx(css.root, pointer && css.pointer, color && css["color-".concat(color)], size && css["size-".concat(size)], sizeXS && css["size-xs-".concat(sizeXS)], sizeS && css["size-s-".concat(sizeS)], sizeM && css["size-m-".concat(sizeM)], sizeL && css["size-l-".concat(sizeL)], sizeXL && css["size-xl-".concat(sizeXL)], vAlign && css["vAlign-".concat(vAlign)], className);
  return svg ? React.createElement("div", {
    className: classNames,
    dangerouslySetInnerHTML: svg && {
      __html: svg
    }
  }, icon ? typeof icon === 'function' ? icon() : icon : ICONS[name]) : React.createElement("div", {
    className: classNames
  }, icon ? typeof icon === 'function' ? icon() : icon : ICONS[name], children);
}

BaseIcon.displayName = 'Icon';
/* Adding enhancers */

var ColoredIcon = function ColoredIcon(props) {
  return React.createElement(Color, _extends({
    InputComponent: BaseIcon
  }, props));
};

var Icon = function Icon(props) {
  return React.createElement(Display, _extends({
    InputComponent: ColoredIcon
  }, props));
};

var oneOf = PropTypes.oneOf,
    object = PropTypes.object,
    bool = PropTypes.bool,
    string = PropTypes.string,
    func = PropTypes.func,
    oneOfType = PropTypes.oneOfType,
    node = PropTypes.node;
BaseIcon.propTypes =
/*#__PURE__*/
_objectSpread({
  children: node,

  /**
   * Name. Can be: phone, ...
   */
  name:
  /*#__PURE__*/
  oneOf(iconNames),

  /**
   * Object with icon's svg. Use for custom icon insertion
   */
  svg: string,

  /**
   * Object with icon's svg. Use for custom icon insertion
   */
  icon:
  /*#__PURE__*/
  oneOfType([object, func]),

  /**
   * Class. Can be: any
   */
  className: string,

  /**
   * Show pointer cursor on hover?
   */
  pointer: bool
},
/*#__PURE__*/
makeComplexAttributePropType([
/*#__PURE__*/
Object.keys(localPropsMap),
/*#__PURE__*/
// eslint-disable-line array-element-newline
Object.keys(breakpoint)],
/*#__PURE__*/
[].concat(
/*#__PURE__*/
_toConsumableArray(
/*#__PURE__*/
Object.keys(sizes)), [false])), {
  /** Vertical align */
  vAlign:
  /*#__PURE__*/
  oneOf(
  /*#__PURE__*/
  Object.keys(vAligns))
});
Object.assign(Icon, {
  localPropsMap: localPropsMap,
  breakpoint: breakpoint,
  size: sizes,
  iconNames: iconNames
});
export { Icon, ICONS };